import React from "react";
import { LockClosedIcon, UserCircleIcon } from "@heroicons/react/solid";
import { ClockIcon } from "@heroicons/react/outline";

export const PoInternalNotes = ({ notes = [], legacyNote, legacyNoteCreatedBy, legacyNoteDate, pendingNoteText, onPendingNoteChange }) => {
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Legacy plain-text internalNotes (pre-structured-notes data) */}
      {legacyNote && legacyNote.trim() && (
        <div className="bg-orange-50 border border-orange-200 rounded-md p-2.5">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <UserCircleIcon className="h-3.5 w-3.5 text-orange-500 flex-shrink-0" />
            <span className="text-xs font-semibold text-orange-700">
              {legacyNoteCreatedBy || "Unknown"}
            </span>
            {legacyNoteDate && (
              <>
                <span className="text-gray-300 text-xs">|</span>
                <ClockIcon className="h-3 w-3 text-gray-400 flex-shrink-0" />
                <span className="text-xs text-gray-500">
                  {formatDate(legacyNoteDate)} &bull; {formatTime(legacyNoteDate)}
                </span>
              </>
            )}
          </div>
          <p className="text-xs text-gray-800 whitespace-pre-wrap break-words">{legacyNote}</p>
        </div>
      )}

      {/* Existing locked notes */}
      {notes.length > 0 ? (
        <div className="flex flex-col gap-2 max-h-52 overflow-y-auto pr-1">
          {notes.map((note) => (
            <div
              key={note.id}
              className="bg-orange-50 border border-orange-200 rounded-md p-2.5"
            >
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <UserCircleIcon className="h-3.5 w-3.5 text-orange-500 flex-shrink-0" />
                <span className="text-xs font-semibold text-orange-700">
                  {note.createdUserName || "Unknown"}
                </span>
                <span className="text-gray-300 text-xs">|</span>
                <ClockIcon className="h-3 w-3 text-gray-400 flex-shrink-0" />
                <span className="text-xs text-gray-500">
                  {formatDate(note.creationDate)} &bull; {formatTime(note.creationDate)}
                </span>
                {/* <LockClosedIcon className="h-3 w-3 text-orange-400 ml-auto flex-shrink-0" title="Locked — cannot be edited" /> */}
              </div>
              <p className="text-xs text-gray-800 whitespace-pre-wrap break-words">
                {note.noteText}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs text-gray-400 italic">No internal notes yet.</p>
      )}

      {/* New note input — saved when the main Save button is clicked */}
      <div className="flex flex-col gap-1 mt-1">
        <textarea
          rows={3}
          placeholder="Add a new note… (will be locked when PO is saved)"
          value={pendingNoteText}
          onChange={(e) => onPendingNoteChange(e.target.value)}
          className="block w-full shadow-sm sm:text-sm text-xs font-normal text-neutral-700 focus:ring-orange-400 focus:border-orange-400 border-gray-300 rounded-md resize-none"
        />

      </div>
    </div>
  );
};
